module.exports = __webpack_public_path__ + "media/images/carousel/banner_9-1a034f964d4f3880d5f222c5b84c849d.jpg";